<template>
  <div class='StepThree'>
    <InitTitle
    text="Identidade visual"
    desc="Envie a logo e escolha as cores do seu negócio para já carregar o sistema com o seu layout."
    />
    <div class="cont">
      <InitInputImg
      width="50%"
      height="80px"
      widthImg="73%"
      label="Logo do estabelecimento"
      desc="Recomendações: proporção horizontal ~4:1, mínimo 400x100px (ideal 800x200px, até 500KB. PNG/SVG transparente recomendado."
      :value="payload.logo"
      @returnValue="newValue => $emit('updateProp', { key: 'logo', value: newValue })"
      :error="verify.logo.$invalid"
      />
      <InitInputImg
      width="25%"
      height="80px"
      widthImg="48%"
      marginLeft="25px"
      label="Favicon"
      desc="Quadrado, mínimo 64x64."
      :value="payload.favicon"
      @returnValue="newValue => $emit('updateProp', { key: 'favicon', value: newValue })"
      :error="verify.favicon.$invalid"
      />
    </div>
    <div class="cont">
      <InitInputImg
      label="Banner"
      widthImg="86%"
      height="150px"
      desc="Recomendado formato panorâmico (ex.: 1600x600)."
      :value="payload.banner"
      @returnValue="newValue => $emit('updateProp', { key: 'banner', value: newValue })"
      :error="verify.banner.$invalid"
      />
    </div>
    <div class="cont between">
      <InitInput
      label="Fonte"
      type="select"
      :options="fonts"
      @returnValue="newValue => $emit('updateProp', { key: 'fonte', value: newValue })"
      :error="verify.fonte.$invalid"
      />
    </div>
    <div class="cont between">
      <InitColorPicker
      label="Cor de destaque"
      width="48.5%"
      :value="payload.corPadrao"
      @returnValue="newValue => $emit('updateProp', { key: 'corPadrao', value: newValue })"
      />
      <InitColorPicker
      label="Fundo principal"
      width="48.5%"
      :value="payload.corFundo"
      @returnValue="newValue => $emit('updateProp', { key: 'corFundo', value: newValue })"
      />
    </div>
    <div class="cont between">
      <InitColorPicker
      label="Fundo dos cartões (superfície)"
      width="48.5%"
      :value="payload.corCard"
      @returnValue="newValue => $emit('updateProp', { key: 'corCard', value: newValue })"
      />
      <InitColorPicker
      label="Cor de texto"
      width="48.5%"
      :value="payload.corFonte"
      @returnValue="newValue => $emit('updateProp', { key: 'corFonte', value: newValue })"
      />
    </div>
    <div class="cont between">
      <InitColorPicker
      label="Cor do nome do estabelecimento"
      width="48.5%"
      :value="payload.corNome"
      @returnValue="newValue => $emit('updateProp', { key: 'corNome', value: newValue })"
      />
      <InitColorPicker
      label="Cor do títulos das categorias"
      width="48.5%"
      :value="payload.corCateg"
      @returnValue="newValue => $emit('updateProp', { key: 'corCateg', value: newValue })"
      />
    </div>
    <div class="cont-message">
      {{ message }}
    </div>
    <div class="cont-next">
      <button v-if="!load" @click="$emit('changeView', 'StepTwo')">Voltar</button>
      <button v-if="!load" @click="next">Próximo</button>
      <VueSpinner v-if="load" size="40"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InitTitle from './InitTitle'
import InitInputImg from './InitInputImg'
import InitInput from './InitInput'
import InitColorPicker from './InitColorPicker'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { VueSpinner } from 'vue3-spinners'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'StepThree',
  components: { InitTitle, InitInputImg, InitInput, InitColorPicker, VueSpinner },
  props: ['payload'],
  data () {
    return {
      load: false,
      message: '',
      verify: {
        logo: { $invalid: false },
        favicon: { $invalid: false },
        banner: { $invalid: false },
        fonte: { $invalid: false }
      }
    }
  },
  computed: {
    ...mapGetters(['Fonts']),
    fonts () {
      let fonts = [ ...this.Fonts ]
      fonts.unshift({ name: '', value: '' })
      return fonts
    },
    logo () {
      return this.payload.logo
    },
    favicon () {
      return this.payload.favicon
    },
    banner () {
      return this.payload.banner
    },
    fonte () {
      return this.payload.fonte
    }
  },
  validations () {
    return {
      logo: {
        required
      },
      favicon: {
        required
      },
      banner: {
        required
      },
      fonte: {
        required
      }
    }
  },
  methods: {
    async next () {
      let valid = await this.v$.$validate()
      if(!valid) {
        this.verify = this.v$
        return
      }
      this.$emit('changeView', 'StepOne')
    }
  }
}
</script>

<style scoped>
.StepThree {
  width: 94%;
  border-radius: 8px;
  padding: 3%;
  background-color: #FFFFFF;
}

.cont {
  display: flex;
  padding-top: 2%;
}

.between {
  justify-content: space-between;
}

.cont-message {
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: end;
  color: red;
}

.cont-next {
  padding-top: 0%;
}

button {
  border: 0;
  margin-top: 3%;
  padding: 11px;
  border-radius: 5px;
  background-color: #0E1E2B;
  color: #FFFFFF;
  cursor: pointer;
  margin: 1%;
  font-size: 18px;
}

@media screen and (max-width: 500px) {
  .cont {
    display: block;
  }
}
</style>
